import React, { useState } from 'react';
import './ProjectArtifacts.css'
import Link from '@mui/material/Link';
import FileUploadComponent from './uploadsample';

const ProjectArtifacts = () => {
  return (
    <>
    <div className="artifact-main-container">
     <h1> Project Artifacts</h1>
     <div className='artifact-sub-container'>
      <Link id='requirements' href = '/ProjectArtifacts/Requirements'>Requirements</Link>
      <Link id='artifacts' href = '/ProjectArtifacts/artifacts'>Artifacts</Link>
      <Link id='review' href = '/ProjectArtifacts/reviews'>Reviews</Link>
      </div>
{/* <FileUploadComponent /> */}
    </div>
    </>
  )
}

export default ProjectArtifacts